import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';
import type { Task } from '../types';

export default function Overdue() {
  const { user } = useAuth();
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadTasks();
  }, [user]);

  const loadTasks = async () => {
    if (!user) return;

    try {
      setLoading(true);
      const data = await api.getOverdueTasks({
        user_id: user.role === 'employee' ? user.id : undefined,
      });
      setTasks(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load overdue tasks');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginBottom: '1rem' }}>Просроченные задачи</h2>

      {error && <div className="error-message">{error}</div>}

      {tasks.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">✅</div>
          <p>Нет просроченных задач!</p>
        </div>
      ) : (
        <div className="task-list">
          {tasks.map((task) => (
            <Link key={task.id} to={`/tasks/${task.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="task-item" style={{ borderLeft: '4px solid var(--danger)' }}>
                <div className="task-header">
                  <span className="task-title">{task.title}</span>
                  <span className="task-status status-pending">Просрочено</span>
                </div>
                <div className="task-meta">
                  {task.due_date && (
                    <span style={{ color: 'var(--danger)' }}>
                      📅 {new Date(task.due_date).toLocaleString('ru-RU')}
                    </span>
                  )}
                  {task.assigned_first_name && (
                    <span className="task-meta-item">👤 {task.assigned_first_name}</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
